import {PageId} from 'modules/decisionsNext/types/pages';

import {decisionsGraphQLClient} from 'modules/decisionsNext/api';
import {
  PageSettingsDocument,
  PageSettingsQuery,
  PageSettingsQueryVariables,
} from 'api/pageSettings/pageSettings.generated';

export const getWhatsNewPageSettings = async () => {
  const result = await decisionsGraphQLClient.query<PageSettingsQuery, PageSettingsQueryVariables>({
    query: PageSettingsDocument,
    variables: {
      pageId: PageId.WhatsNew,
    },
  });

  if (result.error) {
    throw result.error;
  }

  return result;
};
